import dayjs from 'dayjs';

import type { Metadata, ZDL } from '../types';

export const buildTitle = (meta: Metadata) => {
  const readApp = meta.read.app.name;
  const writeApp = meta.write.app.name;
  const date = dayjs().format('MMMM D, YYYY');
  return `${readApp} → ${writeApp} (${date})`;
};

export const buildDescription = ({ read, write }: Metadata) =>
  `For every ${read.action.noun} in ${read.app.name}, create a ${write.action.noun} in ${write.app.name}`;

export const buildZDL = (
  { read, write }: Metadata,
  /** `true` if building a scheduled transfer */
  isRecurringTransfer?: boolean
): ZDL => ({
  app: 'EngineAPI',
  type: 'run',
  action: 'series_skip_errors',
  id: '_GEN_root',
  zdl_version: '0.4',
  steps: [
    {
      action: read.action.key,
      app: read.app.selected_api,
      id: '_GEN_read',
      meta: {
        transfer: {
          isRecurring: !!isRecurringTransfer,
        },
      },
      params: {},
      type: read.action.type,
    },
    {
      action: write.action.key,
      app: write.app.selected_api,
      id: '_GEN_write',
      meta: {},
      params: {},
      type: write.action.type,
    },
  ],
});
